import styled from "@emotion/styled";

export const Container = styled.div`
padding: 25px;
width: 800px;
margin: 0 auto;
`;

export const SnakeContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
